<template>
  <div :class="{ sidebar: true, 'is-sidebar': collapse }">
    <!-- 折叠按钮 -->
    <hamburger
      id="hamburger-container"
      :is-active="!collapse"
      :is-show="this.userInfo.userInfo.isAuth"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <!-- 搜索 -->
    <div class="input-sidebar" v-if="!collapse && this.userInfo.userInfo.isAuth != '1'">
      <el-input
        placeholder="请输入内容"
        prefix-icon="el-icon-search"
        v-model="searchValue"
        filterable
        clearable
        class="inputIcon"
      ></el-input>
    </div>
    <el-menu
      :unique-opened="true"
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      :default-openeds="openeds"
      background-color="#fdfdfd"
      text-color="#333"
      active-text-color="#606266"
      :collapse-transition="false"
      mode="vertical"
      router
    >
      <!--logo-->
      <!-- <logo :collapse="isCollapse" /> -->
      <template v-for="value in menuList">
        <template v-if="value.children.length > 0">
          <el-submenu :key="value.id" :index="value.id" class="first">
            <template slot="title">
              <svg-icon
                class="icon-img"
                style="font-size: 16px"
                :icon-class="value.attributes.menuStyle"
              />
              <span slot="title" style="margin-left: 10px">{{ value.label }}</span>
            </template>
            <MenuTree :menu-data="value.children" />
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item
            :key="value.id"
            :index="value.index == '' ? value.id : value.index"
            @click="getMenuCode(value)"
            class="second"
          >
            <svg-icon
              class="icon-img"
              style="font-size: 16px"
              :icon-class="value.attributes.menuStyle"
            />
            <span slot="title" style="margin-left: 10px">{{ value.label }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/login';
  import MenuTree from '@/components/menuTree';
  import bus from '../common/js/bus';
  import Hamburger from '@/components/Hamburger';
  import { generateTitle } from '@/common/js/util.js';

  export default {
    components: {
      Hamburger,
      MenuTree,
    },
    data() {
      return {
        collapse: false,
        items: [],
        openeds: [],
        menuList: [],
        searchValue: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      onRoutes() {
        return this.$route.path;
      },
      isCollapse() {
        return this.collapse;
      },
    },
    watch: {
      searchValue(str) {
        const result = this.filterMenuTree(this.items, str);
        this.menuList = result;
      },
    },
    created() {
      // 通过 Event Bus 进行组件间通信，来折叠侧边栏
      bus.$on('collapse', (msg) => {
        this.collapse = msg;
      });
      bus.$on('collection', () => {
        this.getMenu();
      });
      // 获取菜单
      this.getMenu();
    },
    mounted() {
      this.toggleSideBar();
    },
    methods: {
      generateTitle,
      filterMenuTree(menus, filterValue) {
        let menuTreeList = [];
        if (filterValue == '') {
          menuTreeList = menus;
          this.openeds = [];
          return menuTreeList;
        } else {
          menus.forEach((item) => {
            if (item.children && item.children.length && item.label.includes(filterValue)) {
              this.openeds.push(item.id);
              menuTreeList.push(item);
            } else if (item.children && item.children.length) {
              const child = this.filterMenuTree(item.children, filterValue);
              const obj = {
                ...item,
                children: child,
              };
              if (child && child.length) {
                this.openeds.push(item.id);
                menuTreeList.push(obj);
              }
            } else {
              if (item.label.includes(filterValue)) {
                this.openeds.push(item.id);
                menuTreeList.push(item);
              }
            }
          });
        }
        return menuTreeList;
      },
      getMenu() {
        if (this.userInfo.userInfo.isAuth === '1') {
          this.menuList = [
            // {
            //   id: 'user',
            //   label: '用户管理',
            //   index: '/system/user',
            //   children: []
            // },
            {
              id: '000001',
              label: '账号管理',
              index: '/system/account',
              attributes: { menuStyle: 'el-icon-account' },
              children: [],
            },
            {
              id: '000002',
              label: '角色管理',
              index: '/system/role',
              attributes: { menuStyle: 'el-icon-user' },
              children: [],
            },
            {
              id: '000003',
              label: '菜单管理',
              index: '/system/menu',
              attributes: { menuStyle: 'el-icon-folder-opened' },
              children: [],
            },
            {
              id: '000004',
              label: '应用管理',
              index: '/system/application',
              attributes: { menuStyle: 'el-icon-goods' },
              children: [],
            },
            {
              id: '000005',
              label: '字典管理',
              index: '/system/dict',
              attributes: { menuStyle: 'el-icon-tickets' },
              children: [],
            },
            {
              id: '000006',
              label: '人员主数据',
              index: '/masterData/personnel',
              attributes: { menuStyle: 'el-icon-people' },
              children: [],
            },
          ];
        } else {
          const params = {
            applicationCode: this.userInfo.userInfo.applicationCode,
          };
          this.$axios.post(API.MENUS_API, params).then(async (res) => {
            if (res.data.code === 0) {
              this.items = res.data.data;
              this.menuList = JSON.parse(JSON.stringify(res.data.data));
              console.log(this.menuList, '全部的菜单');
              const firstMenus = this.menuList[0];
              if (firstMenus.label == '首页') {
                const firstChild = firstMenus.children[0];
                const itemList = firstChild.index.split('/');
                console.log(itemList, '------->>>');
                this.$store.dispatch('menu/setIndexType', itemList[itemList.length - 1]);
              } else {
                this.$store.dispatch('menu/setIndexType', '');
              }
              let mdIndex = this.menuList.findIndex((item) => item.label == '主数据管理');
              let obj = {
                attributes: {
                  applicationCode: null,
                  authCode: '',
                  companyCode: null,
                  createBy: null,
                  gmtCreate: null,
                  gmtModified: null,
                  id: null,
                  isDeleted: null,
                  lastModifiedBy: null,
                  level: 0,
                  menuCode: '',
                  menuCodes: null,
                  menuName: 'MDG推送记录',
                  menuStyle: 'el-icon-user',
                  menuUrl: '/system/account',
                  newAuthCode: null,
                  oldAuthCode: null,
                  outUrl: '',
                  parentAuthCode: null,
                  parentMenuCode: '',
                  referenceType: 'inner',
                  remark: null,
                  roleCode: null,
                  sortNo: 10,
                  tenantCode: null,
                  type: '1',
                  userCode: null,
                  version: '1',
                },
                children: [],
                code: null,
                id: '',
                index: '/system/account',
                isDisabled: false,
                label: '账号管理',
                pid: '',
                treeCode: null,
                type: 'menu',
              };
              let hasHn = await this.$baseRequest.hasHnPer(); //判断是否有海宁权限
              if (mdIndex >= 0 && hasHn) {
                this.menuList[mdIndex].children.push(obj);
              }
              this.$store.dispatch('menu/setMenuList', this.menuList);
              this.getNextLevel(this.menuList);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      // 获取下一级
      getNextLevel(list) {
        list.map((item) => {
          if (item.children.length > 0) {
            this.getNextLevel(item.children);
          } else {
            if (item.attributes.referenceType == 'guandata') {
              let obj = {
                id: item.id,
                name: item.index,
                url: item.attributes.outUrl,
              };
              this.$store.dispatch('outUrl/setOutUrlList', obj);
            }
          }
        });
      },
      // 获取菜单code 查询按钮权限时用到
      getMenuCode(item) {
        this.userInfo.userInfo.menuCode = item.id;
        this.$store.commit('saveUserInfo', this.userInfo.userInfo);
        // this.$store.dispatch('tagsView/delAllViews')
      },
      toggleSideBar() {
        this.collapse = !this.collapse;
        bus.$emit('collapse', this.collapse);
      },
    },
  };
</script>

<style lang="scss">
  .el-menu--vertical {
    left: 58px !important;
    width: 160px;
    height: 38px;
    ::v-deep .el-menu-item {
      width: 160px;
    }
    .el-menu--collapse .el-menu .el-submenu,
    .el-menu--popup {
      min-width: 160px;
    }
    .el-submenu .el-menu-item {
      min-width: 160px;
    }
    .el-menu-item,
    .el-submenu__title {
      height: 28px !important;
      line-height: 28px !important;
      margin: 0;
    }
    .el-submenu__title {
      width: 160px;
    }
    .el-menu--popup-right-start {
      border-radius: 6px;
      .el-menu--vertical {
        //top: 0!important;
        left: 160px !important;
      }
    }
  }
</style>

<style lang="scss" scoped>
  $bg: #fdfdfd;

  ::v-deep .sidebar-el-menu {
    padding-right: 10px;
    .el-menu--inline {
      width: 250px;
    }
    .el-menu-item {
      border-left: 4px solid transparent;
    }
  }
  .sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 60px;
    bottom: 0;
    overflow-y: scroll;
    background-color: $bg;
    .el-menu {
      border-right: 0;
    }
    .hamburger-container {
      line-height: 56px;
      cursor: pointer;
      background: $bg;
    }
    ::v-deep .el-submenu__title {
      width: 250px;
    }
    ::v-deep .first > .el-submenu__title {
      border-left: 4px solid transparent;
      background-color: #fdfdfd !important;
    }
    ::v-deep .el-submenu__title:hover {
      // background-color: #1d2c33;
      border-left: 4px solid #fdfdfd;
    }
    ::v-deep .is-opened > .el-submenu__title:first-child {
      border-left: 4px solid #fdfdfd;
    }
    ::v-deep .el-menu-item:hover {
      // background-color: #000000 !important;
    }
    ::v-deep .el-menu-item.is-active {
      background-color: #e6eaee !important;
    }
    ::v-deep .second {
      background-color: #fdfdfd !important;
      border-left: 4px solid transparent;
      .icon-img {
        padding-right: 10px;
        color: #333333;
      }
    }
    ::v-deep .second.el-menu-item:hover {
      // background-color: #000000 !important;
      border-left: 4px solid #fdfdfd;
    }
    ::v-deep .second.is-active {
      // background-color: #000000 !important;
    }
    ::v-deep .el-menu-item {
      width: 250px;
    }
  }
  .el-menu {
    width: 250px;
    text-align: center;
    background-color: #fdfdfd !important;
  }
  .is-sidebar {
    ::v-deep .el-submenu__title {
      width: 76px !important;
    }
    ::v-deep .el-menu {
      width: 76px;
    }
    ::v-deep .el-menu-item.second {
      width: 76px;
    }
    ::v-deep .second.is-active {
      // background-color: #000000 !important;
    }
  }
  .sidebar::-webkit-scrollbar {
    width: 0;
  }
  .sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
    overflow-y: auto;
    text-align: left;
    .icon-img {
      cursor: pointer;
      vertical-align: middle;
      text-align: center;
    }
  }
  .sidebar > ul {
    height: 100%;
  }
  .input-sidebar {
    left: 20px;
    position: absolute;
    top: 10px;
    width: 170px;
    //::v-deep .el-icon-search {
    //  background: url("../icons/svg/search-top.svg") center center no-repeat;
    //  background-size: 100px;
    //}
    ::v-deep .el-icon-search:before {
      content: '替';
      font-size: 16px;
      visibility: hidden;
    }
    ::v-deep .el-input--small .el-input__inner {
      height: 36px;
      line-height: 36px;
    }
    // ::v-deep .el-input__inner {
    //   background-color: #333333;
    //   border: 1px solid #333333;
    // }
  }
</style>
